// extracted by mini-css-extract-plugin
module.exports = {"btn--open":"styles_btn--open__2rnBW","icon":"styles_icon__45ZEG"};